import { useUser } from 'src/hook/useUser'
import { CharsCounterProps } from './charsCounter.types'
import { Wrapper } from './charsCounter.styles'

const CharsCounter = ({ value, limit }: CharsCounterProps) => {
  const { locale } = useUser()

  return (
    <Wrapper
      data-test="input-counter"
      className="_text-1 _text-gray-500 _position-absolute _d-flex _flex-row _align-items-center _justify-content-start _mr-3"
    >
      <div className="_mt-2">
        <span>{value?.length.toLocaleString(locale)}</span>
        <span>/</span>
        <span>{limit.toLocaleString(locale)}</span>
      </div>
    </Wrapper>
  )
}

export default CharsCounter
